import {getSeededRandom} from "../utils/DataUtilities";
import {useContext, useMemo} from "react";
import {StoreContext} from "../stores/StoreLoader";
import {values} from "mobx";

export function useHeroMediaItem(isWelcomePage) {
    const {organizationStore, gridStore} = useContext(StoreContext);

    return useMemo(() => {
        if (isWelcomePage) {
            let customHero = organizationStore.hero.filter(media => media.enabled);
            if (customHero?.slice && Array.isArray(customHero.slice()) && customHero.length > 0) {
                // if there are custom media, pick one randomly
                return getSeededRandom(customHero);
            } else if (organizationStore.organization?.media) {
                const media = organizationStore.organization.media;
                return getSeededRandom(media);
            }
        } else if (organizationStore.currentOrganization.json_data?.terracedGrid?.enabled) {
            const heroBlock = values(gridStore.blocks).find(b => b.type === "hero");
            if (heroBlock) {
                return getSeededRandom(heroBlock.media_items);
            }
        }
    }, []);
}
